import React from 'react';
import { isMobile } from 'styles/utils';

type SelectTagsProps = {
  sourceData: Record<string, string>[];
  selectKeys: string[];
  activeStyle: React.CSSProperties;
  inactiveStyle: React.CSSProperties;
  onClickItem: (key: string) => void;
};

export const SelectTags: React.FC<SelectTagsProps> = ({
  sourceData,
  selectKeys,
  activeStyle,
  inactiveStyle,
  onClickItem,
}) => {
  return (
    <>
      <div
        className={`${
          isMobile() ? 'w-full' : 'w-3/5 '
        } flex flex-wrap justify-center`}
      >
        {sourceData.map(({ value, label, src }) => {
          const active = selectKeys.some(v => v === value);

          const style: React.CSSProperties = active
            ? activeStyle
            : inactiveStyle;

          return (
            <>
              <div
                className='flex border justify-center rounded-full cursor-pointer'
                key={value}
                style={style}
                onClick={() => {
                  onClickItem(value);
                }}
              >
                {src && <img width={24} className='block mx-1' src={src} />}
                {label}
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};
